export default __webpack_public_path__ + "static/media/location.8ea673f1.svg";